import { render, staticRenderFns } from "./ReleasesTopSlot.vue?vue&type=template&id=2c91c1f1"
import script from "./ReleasesTopSlot.vue?vue&type=script&lang=js"
export * from "./ReleasesTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports